import React from 'react';
import PropTypes from 'prop-types';

/**
 * This handle user sign-in and get a code authorization of Oauth providers.
 */
export class LoginWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.externalWindow = null;
    this.codeCheck = null;

    if (typeof window !== 'undefined') {
        this.createPopup = () => {
          const {
            authorizationUrl, clientId, redirectUri, responseType, scope, title, width, height, onCode,
          } = this.props;
          const left = window.screenX + (window.outerWidth - width) / 2;
          const top = window.screenY + (window.outerHeight - height) / 2.5;
          this.externalWindow = window.open(
            `${authorizationUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&display=popup`,
            title,
            `width=${width},height=${height},left=${left},top=${top}`,
          );
          this.codeCheck = setInterval(() => {
            try {
              const params = new URL(this.externalWindow.location).searchParams;
              const code = params.get('code');
              if (!code) return;
              clearInterval(this.codeCheck);
              onCode({ ...this.props, code }); // returns the code
              this.externalWindow.close();
            } catch (e) {
              // we can ignore exception errors while window opened.
            }
          }, 100);
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            this.externalWindow.pagehide = () => clearInterval(this.codeCheck);
          } else {
            this.externalWindow.onbeforeunload = () => clearInterval(this.codeCheck);
          }
        };
    }
  }

  componentWillUnmount() {
    if (this.externalWindow) this.externalWindow.close();
  }

  /**
   * Render the Oauth popup and listen the callback of authorization service.
   */
  render() {
    const { children } = this.props;
    return (
      <div role="button" tabIndex={0} onKeyPress={this.createPopup} onClick={this.createPopup}>
        {children}
      </div>
    );
  }
}

/**
 * Define the default props to open the dialog authorization.
 */
LoginWrapper.defaultProps = {
  width: 450,
  height: 635,
  title: '',
  redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/` : '',
  scope: null,
  children: null,
};

/**
 * Available props to use on component render.
 */
LoginWrapper.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  title: PropTypes.string,
  scope: PropTypes.string,
  authorizationUrl: PropTypes.string.isRequired,
  redirectUri: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  responseType: PropTypes.string.isRequired,
  // provider: PropTypes.string.isRequired,
  onCode: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default LoginWrapper;
